import theme from '../../base';

const autoComplete = {
  background: theme.colors.neutrals.gray800,
  itemHover: theme.colors.neutrals.gray700,
  text: theme.colors.neutrals.gray200,
  category: theme.colors.neutrals.gray500,
  divider: theme.colors.neutrals.gray700,
  border: theme.colors.neutrals.gray700,
};

export default autoComplete;
